/**
* Renders a pulsing placeholder for the history cards while the real data is loading.
* @example
* HistorySkeleton()
* <div className="animate-pulse space-y-4">...</div>
* @param {{void}} none - No arguments are required.
* @returns {{JSX.Element}} A skeleton layout mimicking the history entries.
**/
const HistorySkeleton = () => {
  return (
    <div className="animate-pulse space-y-4">
      {/* History Cards */}
      {[1, 2, 3].map((i) => (
        <div key={i} className="bg-background-secondary rounded-lg p-6 border border-border-primary">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <div className="h-6 bg-background-tertiary rounded w-3/4 mb-3" />
              <div className="h-4 bg-background-tertiary rounded w-1/2 mb-2" />
            </div>
            <div className="w-20 h-6 bg-background-tertiary rounded" />
          </div>
          
          <div className="flex items-center gap-6 mt-4">
            <div className="flex items-center gap-2">
              <div className="h-4 bg-background-tertiary rounded w-16" />
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 bg-background-tertiary rounded w-20" />
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 bg-background-tertiary rounded w-24" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HistorySkeleton;
